var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoAmount = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ico_amount",
    d: "M271.86,789.657c3.433,0,6-1.333,6-2.525s-2.571-2.526-6-2.526-6,1.339-6,2.526S268.432,789.657,271.86,789.657Zm0,10.106a12.634,12.634,0,0,0,1.442-.08,6.7,6.7,0,0,1-.946-1.612c-.165,0-.33.009-.5.009A12.142,12.142,0,0,1,266.633,797a6.7,6.7,0,0,1-.772-.443v.672C265.861,798.43,268.432,799.763,271.86,799.763Zm0-3.367h.052a6.677,6.677,0,0,1,0-1.683h-.052a12.152,12.152,0,0,1-5.226-1.076,6.9,6.9,0,0,1-.772-.438v.671C265.862,795.062,268.427,796.4,271.86,796.4Zm0-3.366c.171,0,.339,0,.5-.011a6.71,6.71,0,0,1,1.073-1.758,14.794,14.794,0,0,1-1.576.084,12.157,12.157,0,0,1-5.227-1.074,6.907,6.907,0,0,1-.772-.439v.672C265.862,791.7,268.427,793.03,271.86,793.03Zm2.572-.267a4.965,4.965,0,0,0-.27,5.134,5.189,5.189,0,0,0,6.941,2.132,5.006,5.006,0,0,0,2.17-6.817,5.187,5.187,0,0,0-6.94-2.132A5.116,5.116,0,0,0,274.432,792.763Z",
    transform: "translate(-265.861 -784.606)",
    fill: "#fff"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoAmount);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_amount.37392201ecd35dec346ec33d98536174.svg";